import { render, staticRenderFns } from "./passage-form.vue?vue&type=template&id=585a2dac&"
import script from "./passage-form.vue?vue&type=script&lang=js&"
export * from "./passage-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports